/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { BrowserRouter, Router } from 'react-router-dom';
import { createBrowserHistory, createMemoryHistory, StaticRouter } from 'history';
import { Chart } from 'react-chartjs-2';
import { ThemeProvider, ServerStyleSheets } from '@material-ui/styles';
import validate from 'validate.js';
import ROUTE from './utils';
import { chartjs } from './helpers';
import theme from './theme';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';
import validators from './common/validators';
import Routing from './Routes';
import {useLogout} from './utils/autoLogout'

const browserHistory = createBrowserHistory();
// const browserHistory = createMemoryHistory();

Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw
});

validate.validators = {
  ...validate.validators,
  ...validators
};
const sheets = new ServerStyleSheets();

let history


if (typeof document !== 'undefined') {
  // const createBrowserHistory = require('history/createBrowserHistory').default

  history = createBrowserHistory()
}

export const App = () => {
  // const timer = useLogout(10);
  // if (timer == 0) {
  //   return <div>Logged Out</div>;
  // }

  // if (timer < 3) {
  //   return <div>In {timer} seconds you will be automatically logged out</div>;
  // }
  // render() {
    return (
      <ThemeProvider theme={theme}>
        {/* <BrowserRouter history={browserHistory}> */}
        
          {/* <Router history={browserHistory}> */}
          {/* <Router history={history}> */}
          <Routing />
      </ThemeProvider>
    )
  // }
}

export default App;
